/**
 *
 *PredDetail.html  init script
 */


document.addEventListener('DOMContentLoaded', function() {

	var isStorage = !!sessionStorage;
	if(isStorage) {
		
		var isStr = StorageOperator.isNotStorageData('session', 'state' );
		if( isStr ) {

			var state = StorageOperator.getStorageData('session', 'state');

			var poolObj = {};

			if(state.poolCateg) {

				var categ = state.poolCateg;
				if(categ==='Normal') {
					poolObj.array = state.or34===3 ? allDataObj.pool3: allDataObj.pool4;
				}else {
					poolObj.array = state.or34===3 ? allDataObj.highPool3: allDataObj.highPool4;
				};

			}else {
				poolObj.array = state.or34===3 ? allDataObj.pool3: allDataObj.pool4;
			};

			init(poolObj);
		}else {

			var isStrLo = StorageOperator.isNotStorageData('local', 'state');
			var or34 = isStrLo ? Number(StorageOperator.getStorageData('local', 'state')['or34']): 3;
			var boo = setState(or34);

			var poolObj = {};
			poolObj.array = allDataObj.pool3;

			init(poolObj)
		};
		
	}else {
		alert('お使いのブラウザでは、本サイトは正常に動作しません');
	};

}, false);



function setState(val) {
			
	var stateObj = StorageOperator.makePageStateJson( val );

	stateObj.coeffValue = COEFF_ARRAY[ COEFF_INDEX ];

	var boo = [false, false];
	try {
		boo = StorageOperator.setStorageData( 'session', 'state', stateObj );		
	}catch(exeption) {
		//alert('お使いのブラウザでは、本サイトは正常に動作しません');
	};
	return boo[0];
};


/*
function initFirst( namae, dataObj ) {
	init( dataObj );
};

var initCount = 0;

var dataObj = {};

function initSecond(name, obj) {
	initCount++;
	//if(initCount===3) {   init();   };

	if(name==='nb_pool') {  dataObj = obj;  };
	if(initCount===2) {
		init( dataObj );
	};
};
*/

var selectViewObj;

function init( dataObj ) {

	//  グローバル変数
	selectViewObj = new SelectView(0, dataObj);

	//  モニターの幅による位置調整
	funcWindowSize();

	//  ウインドウのサイズが変更されたときの処理登録
	window.addEventListener("resize", funcResize, false);

	funcSetPopup();
	//
	
	let stateObj = StorageOperator.getStorageData('session', 'state');
	if( stateObj.poolCateg ) {
		let categ = stateObj.poolCateg===POOL_CATEG[0] ? POOL_CATEG_TEXT[0] : POOL_CATEG_TEXT[1];
		document.getElementById('poolCategText').textContent = categ;
	}else {
		document.getElementById('poolCategText').textContent = POOL_CATEG_TEXT[0];
	};
};


//モニターの幅による位置調整
function funcWindowSize() {

	var width = window.innerWidth;
	if(width >= 600 && width <= 960) {
		document.getElementById("popupDiv").style.right = ((width - 604)/2)+"px";
	}else if(width < 600) {
		document.getElementById("popupDiv").style.right = "5px";
	};
	return width;
};

//ウインドウのサイズが変更されたときの処理関数
function funcResize() {

	var width = funcWindowSize();

	if(width >= 520) {
		document.getElementById("popupDiv").style.display = "block";
		document.formPopup.popupState.value = "show";
	};
};

function funcSetPopup() {
	var state = document.formPopup.popupState.value;

	if(state=="close") {
		document.getElementById("popupDiv").style.display = "none";
	};
};

//
function popupWindow() {

	var state = document.formPopup.popupState.value;
	if(state=="show") {
		document.formPopup.popupState.value = "close";
		document.getElementById("popupDiv").style.display = "none";
	}else {
		document.formPopup.popupState.value = "show";
		document.getElementById("popupDiv").style.display = "block";
	};
};


